import React from "react";
import PropTypes from "prop-types";

export default function Navbar(Props) {
  return (
    <div>
      <nav className="navbar">
  <div className="container-fluid">
    <a className="navbar-brand" href="/">
      <img src="https://www.joydeepdeb.com/images/change-case.jpg"alt="Logo" width="100" height="70" className="d-inline-block align-text-center"/>
      <h2> Case_Converter</h2>
    </a>
  </div>
</nav>
    </div>
  );
}